window.contacts = function () {
  'use strict';
  // $('#btn_submit').prop('disabled', true);
  const $form_contact = $('#contactForm');
  const validator = $form_contact.validate({
    rules: {
      name: "required",
      contact: "required",
      email: {
        required: true,
        email: true
      },
      subject: "required",
      message: "required",
      rgpdDisclaimer: "required"
    },
    messages: {
      name: trans('frontend.The name is a required field'),
      contact: trans('frontend.The contact is a required field'),
      email: {
        required: trans('frontend.We need your email address to contact you'),
        email: trans('frontend.Your email address must be in the format of name@domain')
      },
      subject: trans('frontend.The subject is a required field'),
      message: trans('frontend.The message is a required field'),
      rgpdDisclaimer: trans('frontend.You must accept the Terms & Conditions')
    },
    submitHandler: function (form, e) {
      var $form = $(form),
        $messageSuccess = $('#contactSuccess'),
        $alerts = $('#alerts'),
        $submitButton = $('#btn_submit');

      $('.loader').removeClass('d-none');

      var formData = {
        _token: $form.find('[name="_token"]').val(),
        name: $form.find('[name="name"]').val(),
        contact: $form.find('[name="contact"]').val(),
        email: $form.find('[name="email"]').val(),
        subject: $form.find('[name="subject"]').val(),
        message: $form.find('[name="message"]').val(),
        rgpdDisclaimer: $form.find('[name="rgpdDisclaimer"]').prop("checked") ? 'on' : 'off',

        contact_address: '',
        contact_accept_news: 'off',
        contact_accept_emails: 'off',
      };

      if ($form.find('[name="rgpdDisclaimer"]').prop('checked')) {
        $form_contact.find('#btn_submit').prop('disabled', false);        // enables button

      }

      $submitButton.button('loading');

      // Ajax Submit
      $.ajax({
        type: "POST",
        url: form.action,
        data: formData,
        dataType: "json",
        encode: true,
      }).done(function (data) {
        if (data.result === "success") {
          $('.loader').addClass('d-none');
          $alerts.css('display', 'flex');
          $alerts.html('');
          $alerts.append(`
           <div class="alert alert-success alert-dismissible fade show" role="alert">
                <span class="message">Contacto submetido com sucesso! </span>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
          `);

          setTimeout(() => {
            $alerts.css('display', 'none');
            $alerts.html('');
          }, 5000);

          // Reset Form
          $form.get(0).reset();

          return;

        } else {
          $('.loader').addClass('d-none');
          $alerts.css('display', 'flex');
          $alerts.html('');
          $alerts.append(`
           <div class="alert alert-danger alert-dismissible fade show" role="alert">
                <span class="message">Ocorreu um erro! </span>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
          `);

          setTimeout(() => {
            $alerts.css('display', 'none');
            $alerts.html('');
          }, 5000);
        }
      });

      e.preventDefault();
      e.stopPropagation();
    },
    invalidHandler: function () {
      $('.loader').addClass('d-none');
      if (validator.numberOfInvalids() > 0) {  // checks form for validity
        console.log(validator.numberOfInvalids());

        $form_contact.find('#btn_submit').prop('disabled', false);        // enables button
      } else {
        $form_contact.find('#btn_submit').prop('disabled', true);   // disables button
      }
    }
  });

  $('#btn_clear').on('click', function () {
    $form_contact.find('[name="_token"]').val('');
    $form_contact.find('[name="name"]').val('');
    $form_contact.find('[name="contact"]').val('');
    $form_contact.find('[name="email"]').val('');
    $form_contact.find('[name="subject"]').val('');
    $form_contact.find('[name="message"]').val('');
    $form_contact.find('[name="rgpdDisclaimer"]').prop('checked', false);
  });
}
